import React from 'react';

// Material UI
import { Grid } from '@mui/material';
import { Alert } from '@mui/material';

// Components
import { Page } from 'components/ui/layout';
import EventLink from './widgets/EventLink';
import HostLink from './widgets/HostLink';
import TrackingLinks from './widgets/TrackingLinks';

// Utility
import { useAuth } from 'context/auth';

export default function Promote(props) {
    const { auth } = useAuth();

    const hostId = auth.hostId;
    const eventId = props.match.params.id;

    return (
        <Page>
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} lg={10}>
                    <Alert severity="info">
                        The links and QR codes below are great to use on your website, Facebook,
                        Instagram, posters and other marketing materials.
                    </Alert>
                </Grid>

                <Grid item xs={12} lg={10}>
                    <HostLink hostId={hostId} />
                </Grid>

                <Grid item xs={12} lg={10}>
                    <EventLink eventId={eventId} />
                </Grid>

                <Grid item xs={12} lg={10}>
                    <TrackingLinks hostId={hostId} eventId={eventId} />
                </Grid>
            </Grid>
        </Page>
    );
}
